import initialState from '../../../store/initialState';
import * as reportconfigurationtypes from '../reportConfiguration/services/reportConfigurationActionType';
import * as reportTypes from '../services/reportActionType'

const types = {...reportconfigurationtypes};

const reportReducer = (state = initialState.report, action) => {
    switch (action.type) {
       
        //Report Configuration - start
        case types.FETCH_REPORT_CONFIGURATION_REQUEST:
            return { ...state, isReportConfigurationLoading: true, };
        case types.FETCH_REPORT_CONFIGURATION_SUCCESS:
            return {
                ...state,
                isReportConfigurationLoading: false,
                reportConfigurationDetails: action.payload?.performanceDashboardConfigList || [],
                capacityTableReportDD: (action.payload?.capacityTableDDList || []).map(item => ({
                    value: item.Id,
                    label: item.Name,
                    ...item
                }))
            };
        case types.FETCH_REPORT_CONFIGURATION_FAILURE:
            return { ...state, isReportConfigurationLoading: false, reportConfigurationDetails: [] };

        case types.SAVE_REPORT_CONFIGURATION_REQUEST:
            return { ...state, isReportConfigurationLoading: true };
        case types.SAVE_REPORT_CONFIGURATION_SUCCESS:
            return { ...state, isReportConfigurationLoading: false };
        case types.SAVE_REPORT_CONFIGURATION_FAILURE:
            return { ...state, isReportConfigurationLoading: false };

        case types.FETCH_REPORT_CONFIGURATION_BY_ID_REQUEST:
            return { ...state, isReportConfigurationLoading: true, };
        case types.FETCH_REPORT_CONFIGURATION_BY_ID_SUCCESS:
            return { ...state, isReportConfigurationLoading: false, selectedReportConfiguration: action.payload };
        case types.FETCH_REPORT_CONFIGURATION_BY_ID_FAILURE:
            return { ...state, isReportConfigurationLoading: false, selectedReportConfiguration: null };
        
        case types.ACTIVATE_DEACTIVATE_REPORT_CONFIGURATION_REQUEST:
            return { ...state, isReportConfigurationLoading: true };
        case types.ACTIVATE_DEACTIVATE_REPORT_CONFIGURATION_SUCCESS:
            return { ...state, isReportConfigurationLoading: false };
        case types.ACTIVATE_DEACTIVATE_REPORT_CONFIGURATION_FAILURE:
            return { ...state, isReportConfigurationLoading: false };

        case types.FETCH_POWERBI_REFRESH_STATUS_REQUEST:
            return { ...state };
        case types.FETCH_POWERBI_REFRESH_STATUS_SUCCESS:
            return { ...state, powerBIRefreshStatus: action.payload };
        case types.FETCH_POWERBI_REFRESH_STATUS_FAILURE:
            return { ...state, powerBIRefreshStatus: null };

        case types.FETCH_CAPACITY_DROPDOWN_REQUEST:
            return { ...state, isCapacityDropdownLoading: true };
        case types.FETCH_CAPACITY_DROPDOWN_SUCCESS:
            return { ...state, isCapacityDropdownLoading: false, capacityTableReportDD: action.payload };
        case types.FETCH_CAPACITY_DROPDOWN_FAILURE:
            return { ...state, isCapacityDropdownLoading: false, capacityTableReportDD: [] };
        //Report Configuration - end

        case reportTypes.FETCH_POWER_BI_REPORT_REQUEST:
            return { ...state, powerBiLoading: true }
        case reportTypes.FETCH_POWER_BI_REPORT_SUCCESS:
            return { ...state, powerBiLoading: false, embedConfig: action.payload }
        case reportTypes.FETCH_POWER_BI_REPORT_FAILURE:
            return { ...state, powerBiLoading: false }

        //common cases
        case types.UPDATE_REPORT_REDUCER:
            return { ...state, ...action.payload };

        default:
            return state;
    }
};

export default reportReducer;